// Spanish translations
export const es = {
  // Navigation
  'nav.overview': 'Resumen',
  'nav.dashboard': 'Panel de control',
  'nav.analytics': 'Análisis',
  'nav.reportingDashboard': 'Panel de informes',
  'nav.sales': 'Ventas',
  'nav.salesOrders': 'Pedidos de venta',
  'nav.purchase': 'Compras',
  'nav.purchaseOrders': 'Pedidos de compra',
  'nav.purchaseReview': 'Espacio de revisión',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Incorporación de proveedores',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Crear sprint',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Planificación semanal',
  'nav.scout.tagesplanung': 'Planificación diaria',
  'nav.scout.prequal': 'Llamadas PreQual',
  'nav.scout.missionen': 'Misiones',
  'nav.scout.missionControl': 'Centro de mando',
  'nav.scout.unternehmenssuche': 'Búsqueda de empresas',
  'nav.scout.preferences': 'Preferencias',
  'nav.scout.hilfe': 'Ayuda',
  'nav.scout.scorecard': 'Cuadro de mando',
  'nav.poSprints': 'PO/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Visualización del soporte',
  'nav.navigationTiles': 'Tiles de navegación',
  'nav.styleGuide': 'Guía de estilo',
  'nav.inventory': 'Inventario',
  'nav.items': 'Artículos',
  'nav.warehouse': 'Almacén',
  'nav.picking': 'Preparación de pedidos',
  'nav.asn': 'ASN',
  'nav.returns': 'Devoluciones',
  'nav.accounting': 'Contabilidad',
  'nav.accountsReceivable': 'Cuentas por cobrar',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Contactos',
  'nav.ai': 'IA',
  'nav.commandCenter': 'Centro de mando',
  'nav.workflows': 'Flujos de trabajo',
  'nav.workflowManagement': 'Gestión de flujos de trabajo',
  'nav.projectManagement': 'Gestión de proyectos',
  'nav.support': 'Soporte',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Tabla dinámica',
  'nav.learning': 'Formación',
  'nav.curriculumPlanning': 'Planificación curricular',
  'nav.learnerDashboard': 'Panel del alumno',
  'nav.accessibleLearnerDashboard': 'Panel del alumno accesible',
  'nav.settings': 'Ajustes',
  'nav.general': 'General',
  'nav.company': 'Empresa',
  'nav.addressManagement': 'Gestión de direcciones',
  'nav.usersRoles': 'Usuarios y roles',
  'nav.auditLog': 'Registro de auditoría',
  'nav.integrations': 'Integraciones',
  'nav.appOverview': 'Resumen de aplicaciones',
  'nav.appOverviewDescription': 'Haz clic en una app para navegar o arrastra las tiles para reordenar',
  'header.help': 'Ayuda',
  'header.account': 'Cuenta',
  'header.portalName': 'Portal CLANDA',
  'header.preferences': 'Preferencias',
  'header.language': 'Idioma',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': 'Eliminar',

  // Messages
  'message.success': 'Éxito',
  'message.error': 'Error',

  // Common
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.save': 'Guardar',
  'common.saveChanges': 'Guardar cambios',
  'common.close': 'Cerrar',
  'common.reset': 'Restablecer',
  'common.back': 'Atrás',
  'common.loading': 'Cargando...',
  'common.search': 'Buscar',
  'common.search.placeholder': 'Buscar...',
  'common.filter': 'Filtrar',
  'common.sort': 'Ordenar',
  'common.add': 'Añadir',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.remove': 'Quitar',
  'common.minutesShort': '{{value}} min',
  'common.na': 'N/D',
  'common.days': 'días',
  'common.status.active': 'activo',
  'common.status.paused': 'pausado',
  'common.status.stopped': 'detenido',
  'common.status.pending': 'pendiente',
  'common.status.completed': 'completado',
  'common.status.planned': 'Planificado',
  'common.status.inProgress': 'En curso',
  'common.status.done': 'Hecho',
  'common.apply': 'Aplicar',
  'common.actions.filter': 'Filtrar',
  'common.actions.export': 'Exportar',
  'common.actions.search': 'Buscar',
  'common.dialog.defaultTitle': 'Diálogo',
  'common.all': 'Todos',
  'common.total': 'Total',
  'common.pending': 'Pendiente',
  'common.assigned': 'Asignado',
  'common.inProgress': 'En curso',
  'common.completed': 'Completado',
  'common.cancelled': 'Cancelado',
  'common.approved': 'Aprobado',
  'common.rejected': 'Rechazado',
  'common.processing': 'Procesando',
  'common.overdue': 'Vencido',
  'common.partial': 'Parcial',
  'common.highPriority': 'Alta prioridad',
  'common.tableView': 'Vista de tabla',
  'common.cardView': 'Vista de tarjetas',
  'common.switchToTable': 'Cambiar a vista de tabla',
  'common.switchToCard': 'Cambiar a vista de tarjetas',
  'common.openMenu': 'Abrir menú',
  'common.details': 'Detalles',
  'common.overview': 'Resumen',
  'common.new': 'Nuevo',
  'common.draft': 'Borrador',
  'common.shipped': 'Enviado',
  'common.delivered': 'Entregado',
  'common.received': 'Recibido',
  'common.inTransit': 'En tránsito',
  'common.itemsPicked': 'Artículos preparados',
  'common.totalRefund': 'Reembolso total',
  'common.totalPrice': 'Precio total',
  'common.orderSummary': 'Resumen del pedido',
  'common.subtotal': 'Subtotal:',
  'common.tax': 'Impuestos:',
  'common.discount': 'Descuento:',
  'common.totalColon': 'Total:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Hoy',
  'dateRange.yesterday': 'Ayer',
  'dateRange.last7Days': 'Últimos 7 días',
  'dateRange.last14Days': 'Últimos 14 días',
  'dateRange.last30Days': 'Últimos 30 días',
  'dateRange.thisMonth': 'Este mes',
  'dateRange.custom': 'Personalizado',

  // Dashboard
  'widget.vsLastPeriod': 'vs período anterior',
  'table.showing': 'Mostrando',
  'table.of': 'de',
  'table.page': 'Página',
  'table.previous': 'Anterior',
  'table.next': 'Siguiente',
  'table.filterGroups': 'Grupos de filtros',
  'table.addFilterGroup': 'Añadir grupo de filtros',
  'table.filterGroup': 'Grupo de filtros',
  'table.addCondition': 'Añadir condición',
  'table.operator': 'Operador',
  'table.field': 'Campo',
  'table.noFilterGroups': 'Sin grupos de filtros.',
  'filter.operator.equals': 'es igual a',
  'filter.operator.not_equals': 'no es igual a',
  'filter.operator.contains': 'contiene',
  'filter.operator.not_contains': 'no contiene',
  'filter.operator.starts_with': 'empieza con',
  'filter.operator.ends_with': 'termina con',
  'filter.operator.gt': 'mayor que',
  'filter.operator.lt': 'menor que',
  'filter.operator.gte': 'al menos',
  'filter.operator.lte': 'como máximo',
  'filter.operator.between': 'entre',
  'filter.operator.in': 'es uno de',
  'filter.operator.not_in': 'no es uno de',
  'filter.operator.is_set': 'está definido',
  'filter.operator.is_not_set': 'no está definido',
  'filter.placeholder.value': 'Valor',
  'filter.placeholder.min': 'Mín',
  'filter.placeholder.max': 'Máx',
  'filter.placeholder.select': 'Seleccionar…',
  'filter.placeholder.selectMultiple': 'Seleccionar valores…',
  'filter.logic.and': 'Y',
  'filter.logic.or': 'O',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Ajustes de la cuenta',

  // Consent
  'consent.title': 'Consentimiento',
  'consent.label': 'Acepto los términos y la política de pedidos',
  'consent.description': 'He leído y acepto los términos.',
  'consent.required': 'Debes aceptar los términos.',
  'consent.link.terms': 'Términos',

  // Contacts
  'contacts.title': 'Contactos',
  'contacts.role': 'Rol',
  'contacts.role.admin': 'Administrador',
  'contacts.role.billing': 'Facturación',
  'contacts.role.technical': 'Técnico',
  'contacts.role.other': 'Otro',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Autenticación',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': '¡Hola {{name}}!',
  'learning.feed.levelInfo': 'Nivel {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Sin conexión',
  'learning.feed.streakLabel': 'Racha de días',
  'learning.feed.dailyGoal': 'Objetivo diario',
  'learning.feed.recommendedLessons': 'Lecciones recomendadas',
  'learning.feed.priority.high': 'Alto',
  'learning.feed.priority.medium': 'Medio',
  'learning.feed.priority.low': 'Bajo',
  'learning.feed.difficulty.easy': 'Fácil',
  'learning.feed.difficulty.medium': 'Medio',
  'learning.feed.difficulty.hard': 'Difícil',
  'learning.feed.aiRecommendation': 'Recomendación IA',
  'learning.feed.actions.start': 'Iniciar',
  'learning.feed.actions.skip': 'Omitir',
  'learning.feed.actions.reload': 'Recargar',
  'learning.feed.empty.title': '¡Todas las lecciones completadas!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Has completado todas las lecciones disponibles hoy. ¡Vuelve mañana!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Pregunta {{current}} de {{total}}',
  'learning.quiz.options.true': 'Verdadero',
  'learning.quiz.options.false': 'Falso',
  'learning.quiz.actions.next': 'Siguiente',
  'learning.quiz.actions.finish': 'Finalizar',
  'learning.quiz.actions.retry': 'Intentar de nuevo',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': '¡Quiz aprobado!',
  'learning.quiz.result.failedTitle': 'Quiz no aprobado',
  'learning.quiz.result.scoreSummary': '{{correct}} de {{total}} correctas',
  'learning.quiz.result.xpEarned': '+{{xp}} XP obtenidos',
  'learning.quiz.result.answersHeading': 'Respuestas detalladas',
  'learning.quiz.result.questionLabel': 'Pregunta {{index}}',
  'learning.quiz.result.yourAnswer': 'Tu respuesta',
  'learning.quiz.result.correctAnswer': 'Respuesta correcta',
  'learning.lessonCard.difficulty.easy': 'Fácil',
  'learning.lessonCard.difficulty.medium': 'Medio',
  'learning.lessonCard.difficulty.hard': 'Difícil',
  'learning.lessonCard.status.completed': 'Completado',
  'learning.lessonCard.reward': 'Recompensa',
  'learning.lessonCard.progress': 'Progreso',
  'learning.lessonCard.selectFormat': 'Elegir formato',
  'learning.lessonCard.prerequisites': 'Requisitos previos',
  'learning.lessonCard.actions.start': 'Iniciar',
  'learning.lessonCard.actions.repeat': 'Repetir',
  'learning.lessonCard.actions.pause': 'Pausar',
  'learning.lessonCard.actions.complete': 'Completar',
  'learning.lessonCard.actions.bookmark': 'Marcar',
  'learning.lessonCard.actions.unbookmark': 'Quitar marcador',
  'learning.lessonCard.actions.collapse': 'Contraer',
  'learning.lessonCard.actions.expand': 'Expandir',
  'learning.lessonCard.goalLabel': 'Objetivo',
  'learning.lessonCard.formats.video': 'Ver vídeo',
  'learning.lessonCard.formats.text': 'Leer texto',
  'learning.lessonCard.formats.audio': 'Escuchar audio',
  'learning.lessonCard.formats.cheatSheet': 'Chuleta',
  'learning.lessonCard.formatUnknown': 'Desconocido',
  'learning.accessible.title': 'Panel de formación',
  'learning.accessible.welcome': 'Bienvenido de nuevo, {{name}}',
  'learning.accessible.voice.start': 'Voz',
  'learning.accessible.voice.stop': 'Dejar de escuchar',
  'learning.accessible.voice.listening': 'Escuchando...',
  'learning.accessible.level': 'Nivel',
  'learning.accessible.xpToNext': '{{value}} XP para el siguiente nivel',
  'learning.accessible.streak': 'Racha',
  'learning.accessible.days': '{{value}} días',
  'learning.accessible.keepItUp': '¡Sigue así!',
  'learning.accessible.badges': 'Insignias',
  'learning.accessible.achievementsEarned': 'Logros obtenidos',
  'learning.accessible.tabs.overview': 'Resumen',
  'learning.accessible.tabs.lessons': 'Lecciones',
  'learning.accessible.tabs.progress': 'Progreso',
  'learning.accessible.tabs.achievements': 'Logros',
  'learning.accessible.recentActivity': 'Actividad reciente',
  'learning.accessible.noRecentActivity': 'No hay actividad reciente',
  'learning.accessible.start': 'Iniciar',
  'learning.accessible.learningProgress': 'Progreso de aprendizaje',
  'learning.accessible.overallProgress': 'Progreso general',
  'learning.accessible.achievements': 'Logros',
  'learning.accessible.startingLesson': 'Iniciando lección {{id}}',
  'learning.accessible.difficulty.beginner': 'Principiante',
  'learning.accessible.difficulty.intermediate': 'Intermedio',
  'learning.accessible.difficulty.advanced': 'Avanzado',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Progreso de racha',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Lección',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Racha',
  'gamification.xpToast.source.badge': 'Insignia',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': '¡Subida de nivel!',
  'gamification.xpToast.levelUp.description': '¡Has alcanzado el nivel {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP obtenidos',
  'gamification.xpToast.button.continue': 'Continuar',
  'gamification.xpToast.streakMilestone.title': '¡Hito de racha!',
  'gamification.xpToast.streakMilestone.description': '¡Racha de {{count}} días conseguida!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP de bonus obtenidos',
  'gamification.close': 'Cerrar',

  // Wissensdatenbank
  'knowledgeBase.back': 'Atrás',
  'knowledgeBase.article.view': 'Ver',
  'knowledgeBase.article.views': '{{count}} visitas',
  'knowledgeBase.article.helpful': '{{count}} útil',
  'knowledgeBase.article.notHelpful': '{{count}} no útil',
  'knowledgeBase.article.byAuthor': 'Por {{author}}',
  'knowledgeBase.header.title': 'Base de conocimientos',
  'knowledgeBase.header.subtitle': 'Encuentra respuestas a tus preguntas',
  'knowledgeBase.actions.filter': 'Filtrar',
  'knowledgeBase.actions.sort': 'Ordenar',
  'knowledgeBase.search.placeholder': 'Buscar en la base de conocimientos...',
  'knowledgeBase.tabs.all': 'Todos',
  'knowledgeBase.stats.popular': 'Artículos más populares',
  'knowledgeBase.stats.viewsCount': '{{count}} visitas',
  'knowledgeBase.stats.helpful': 'Artículos más útiles',
  'knowledgeBase.stats.ratingsCount': '{{count}} valoraciones',
  'knowledgeBase.stats.total': 'Total de artículos',
  'knowledgeBase.stats.totalCount': '{{count}} artículos',
  'knowledgeBase.empty.title': 'No se encontraron artículos',
  'knowledgeBase.empty.searching': 'Prueba otros términos de búsqueda o revisa las categorías.',
  'knowledgeBase.empty.default': 'Aún no hay artículos en esta categoría.',
  'knowledgeBase.difficulty.beginner': 'Principiante',
  'knowledgeBase.difficulty.intermediate': 'Intermedio',
  'knowledgeBase.difficulty.advanced': 'Avanzado',
  'knowledgeBase.categories.odoo-basics': 'Conceptos básicos de Odoo',
  'knowledgeBase.categories.crm': 'CRM y ventas',
  'knowledgeBase.categories.inventory': 'Inventario y compras',
  'knowledgeBase.categories.accounting': 'Contabilidad',
  'knowledgeBase.categories.projects': 'Gestión de proyectos',
  'knowledgeBase.categories.troubleshooting': 'Resolución de problemas',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Vídeo',
  'curriculum.videoDescription': 'Grabación de pantalla o vídeo práctico',
  'curriculum.cheatSheet': 'Chuleta',
  'curriculum.cheatSheetDescription': 'Listo para imprimir, códigos QR',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Encuesta Odoo, 10 preguntas, 80%',
  'curriculum.checklist': 'Lista de comprobación',
  'curriculum.checklistDescription': 'Tareas Odoo, clicables',
  'curriculum.textLesson': 'Texto/Lección',
  'curriculum.textLessonDescription': 'Lección de curso Odoo',
  'curriculum.roleplay': 'Role play',
  'curriculum.roleplayDescription': 'En vivo con mentor/Benno',
  'curriculum.practice': 'Tarea práctica',
  'curriculum.practiceDescription': 'Realizar con el cliente',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Resumen semanal',
  'scout.wochenplanung.previousWeek': 'Semana anterior',
  'scout.wochenplanung.nextWeek': 'Semana siguiente',
  'scout.wochenplanung.toast.appointmentAdded': 'Cita añadida',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Cita actualizada',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Cita eliminada',
  'scout.wochenplanung.toast.slotUpdated': 'Slot actualizado',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Misión resuelta o slot eliminado.',

  // Planning legend
  'scout.wochenplanung.legend.completed': 'completado',
  'scout.wochenplanung.legend.planned': 'planificado',
  'scout.wochenplanung.legend.partial': 'parcialmente planificado',
  'scout.wochenplanung.legend.unplanned': 'por planificar',
  'scout.wochenplanung.legend.holiday': 'Festivo / Vacaciones',

  // Missions section

  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Eliminar cita',
  'scout.wochenplanung.dialog.deleteAppointment.description': '¿Seguro que quieres eliminar esta cita? Esta acción no se puede deshacer.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Editar cita',
  'scout.wochenplanung.dialog.editAppointment.description': '¿Aplicar los cambios a esta cita?',
  'scout.wochenplanung.employee': 'Empleado',
  'scout.wochenplanung.selectEmployee': 'Seleccionar empleado',
  'scout.wochenplanung.allEmployees': 'Todos los empleados',
  'scout.wochenplanung.error.loading': 'Error al cargar la planificación semanal',
  'scout.wochenplanung.error.retry': 'Reintentar',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': 'Resumen del equipo',
  'scout.missionControl.teamMembers': 'Miembros del equipo',
  'scout.missionControl.table.employee': 'Empleado',
  'scout.missionControl.table.team': 'Equipo',
  'scout.missionControl.table.plzAreas': 'Áreas PLZ',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Error al cargar clientes existentes',
  'scout.missionen.bestandskunden.empty': 'No se encontraron clientes existentes',
  'scout.missionen.bestandskunden.search': 'Buscar clientes existentes...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} de {{total}} clientes existentes',
  'scout.missionen.wunschliste.industriesTitle': 'Industrias preferidas',
  'scout.missionen.wunschliste.productsTitle': 'Productos preferidos',
  'scout.missionen.wunschliste.plzTitle': 'Regiones de código postal preferidas',
  'scout.missionen.wunschliste.saveButton': 'Guardar',
  'scout.missionen.wunschliste.saved': 'Guardado',
  'scout.missionen.wunschliste.savedDesc': 'Tus preferencias se han guardado.',
  'scout.missionen.wunschliste.saveError': 'Error',
  'scout.missionen.wunschliste.saveErrorDesc': 'No se pudieron guardar las preferencias.',
  'scout.missionen.wunschliste.loadError': 'Error al cargar preferencias',
  'scout.tagesplanung.title': 'Planificación diaria',
  'scout.tagesplanung.addressUnknown': 'Dirección desconocida',
  'scout.tagesplanung.routeMapLabel': 'Mapa de ruta',
  'scout.tagesplanung.routePlanning': 'Planificación de rutas',
  'scout.tagesplanung.traffic': 'Tráfico',
  'scout.tagesplanung.deferNotPossible': 'No se puede aplazar',
  'scout.tagesplanung.deferMaxReached': 'Número máximo de aplazamientos para hoy alcanzado (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Este lead ya se aplazó hoy.',
  'scout.tagesplanung.dayCannotClose': 'No se puede cerrar el día',
  'scout.tagesplanung.outstandingReports': 'Hay {{count}} informes de visita pendientes. Complétalos antes de cerrar el día.',
  'scout.tagesplanung.andMore': '... y {{count}} más',
  'scout.tagesplanung.tabs.planning': 'Plan del día',
  'scout.tagesplanung.tasks.tabLabel': 'Tareas',
  'scout.tagesplanung.tasks.empty': 'Sin tareas',
  'scout.tagesplanung.tasks.loading': 'Cargando tareas',
  'scout.tagesplanung.tasks.error': 'No se pudieron cargar las tareas',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Estado',
  'scout.tagesplanung.tasks.filterStatusTodo': 'Por hacer',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'En curso',
  'scout.tagesplanung.tasks.filterStatusDone': 'Hecho',
  'scout.tagesplanung.tasks.priorityLabel': 'Prioridad',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Vencimiento',
  'scout.tagesplanung.tasks.dueNone': 'Sin fecha de vencimiento',
  'scout.lead.neukunde': 'Cliente nuevo — producto de nicho como puerta de entrada',
  'scout.lead.bestandskunde': 'Cliente existente',
  'scout.metrics.besuche': 'Visitas',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Pedidos',
  'scout.metrics.umsatz': 'Ingresos',
  'scout.metrics.demoRate': 'Tasa de demo',
  'scout.composition.title': 'Composición de misión',
  'scout.composition.minBestandskunden': 'Mín. clientes existentes',
  'scout.composition.minQualifiziert': 'Mín. leads cualificados',
  'scout.composition.maxKaltbesuche': 'Máx. visitas en frío',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Añadir cita',
  'scout.dailyPlanning.appointments': 'Citas',
  'scout.dailyPlanning.noAppointmentsPlanned': 'No hay citas planificadas para este día',
  'scout.dailyPlanning.leadsByPriority': 'Leads (por prioridad)',
  'scout.dailyPlanning.noLeadsPlanned': 'No hay leads planificados para este día',
  'scout.dailyPlanning.skipLead': 'Omitir lead',
  'scout.dailyPlanning.skipLeadConfirmation': '¿Seguro que quieres omitir este lead? Se moverá al día siguiente.',
  'scout.dailyPlanning.skip': 'Omitir',
  'scout.dailyPlanning.removeLead': 'Quitar lead',
  'scout.dailyPlanning.removeLeadConfirmation': '¿Seguro que quieres quitar este lead? Se eliminará por completo de la rotación.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Elige una misión para ver los leads',
  'scout.dailyPlanning.selectDate': 'Seleccionar fecha',
  'scout.dailyPlanning.nextDay': 'Día siguiente',
  'scout.dailyPlanning.closeDay': 'Cerrar día',
  'scout.dailyPlanning.reopenDay': 'Reabrir día',
  'scout.dailyPlanning.noAcceptedLeads': 'No hay leads aceptados para este día.',
  'scout.dailyPlanning.statusSkipped': 'Omitido',
  'scout.dailyPlanning.selectAll': 'Seleccionar todo',
  'scout.dailyPlanning.selectAllLeads': 'Seleccionar todos los leads',
  'scout.dailyPlanning.noSuggestions': 'Sin sugerencias.',
  'scout.dailyPlanning.previousDay': 'Día anterior',
  'scout.dailyPlanning.calendarWeek': 'Semana {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visita',
  'scout.dailyPlanning.details': 'Detalles',
  'scout.dailyPlanning.missionsLoading': 'Cargando misiones…',
  'scout.dailyPlanning.leadsLoading': 'Cargando leads…',
  'scout.dailyPlanning.noLeadsFound': 'No se encontraron leads',
  'scout.dailyPlanning.moreLeads': 'más',
  'scout.dailyPlanning.dailyList': 'Lista diaria',
  'scout.dailyPlanning.unknown': 'Desconocido',
  'scout.dailyPlanning.suggestedLeads': 'Leads sugeridos',
  'scout.dailyPlanning.error': 'Error: {{error}}',
  'scout.dailyPlanning.help': 'Ayuda',
  'scout.dailyPlanning.bulkActions': 'Acciones masivas',
  'scout.dailyPlanning.actionsCount': 'Acciones ({{count}})',
  'scout.dailyPlanning.accept': 'Aceptar',
  'scout.dailyPlanning.reject': 'Rechazar',
  'scout.dailyPlanning.selectLead': 'Seleccionar lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Abrir detalles de {{name}}',
  'scout.dailyPlanning.score': 'Puntuación: {{score}}',
  'scout.dailyPlanning.loading': 'Cargando planificación diaria',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Seleccionar métrica del mapa de calor',
  'scout.scorecard.orders': 'Pedidos',
  'scout.scorecard.annualTargetOrders': 'Objetivo anual de pedidos',
  'scout.scorecard.comingSoon': 'Próximamente',
  'scout.scorecard.kpiOverview': 'Resumen KPI, actividades e industrias principales',
  'scout.scorecard.activityByDay': 'Actividad por día',
  'scout.scorecard.title': 'Cuadro de mando',
  'scout.scorecard.period.tag': 'Día',
  'scout.scorecard.period.woche': 'Semana',
  'scout.scorecard.period.monat': 'Mes',
  'scout.scorecard.period.jahr': 'Año',
  'scout.scorecard.kpiTilesHeading': 'KPI',
  'scout.scorecard.topBranchenProdukteHeading': 'Principales industrias y productos',
  'scout.scorecard.soll': 'Objetivo',
  'scout.scorecard.forecast': 'Previsión',
  'scout.scorecard.gapToGo': 'Gap restante',
  'scout.scorecard.csvExport': 'Exportar CSV',
  'scout.scorecard.pdfExport': 'Exportar PDF',
  'scout.scorecard.table.date': 'Fecha',
  'scout.scorecard.table.visits': 'Visitas',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Pedidos',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Ingresos netos',
  'scout.scorecard.table.total': 'Total',
  'scout.scorecard.topBranchen': 'Principales industrias',
  'scout.scorecard.topProdukte': 'Principales productos',
  'scout.scorecard.table.industry': 'Industria',
  'scout.scorecard.table.quantity': 'Cantidad (unidades)',
  'scout.scorecard.table.revenue': 'Ingresos (€)',
  'scout.scorecard.table.product': 'Producto',
  'scout.scorecard.table.salesVolume': 'Volumen de ventas',
  'scout.scorecard.table.customers': 'Clientes',
  'scout.scorecard.kpi.visits': 'Visitas',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Pedidos',
  'scout.scorecard.kpi.netRevenue': 'Ingresos netos',
  'scout.scorecard.kpi.gebinde60l': 'Unidades 60L',
  'scout.scorecard.kpi.gebinde25l': 'Unidades 25L',
  'scout.scorecard.kpi.gebinde10l': 'Unidades 10L',
  'scout.scorecard.emptyTitle': 'Sin datos',
  'scout.scorecard.emptyDescription': 'No hay datos KPI para el período seleccionado.',
  'scout.scorecard.missionPerformanceTitle': 'Rendimiento de misiones',
  'scout.scorecard.missionMissionsCompleted': 'Misiones completadas',
  'scout.scorecard.missionConversionRate': 'Tasa de conversión',
  'scout.scorecard.missionTerritoryCoverage': 'Cobertura territorial',
  'scout.scorecard.viewMissionDetails': 'Ver detalles',
  'scout.scorecard.adjustTargets': 'Ajustar objetivos',
  'scout.scorecard.annualTarget': 'Objetivo anual',
  'scout.scorecard.annualTargetVisits': 'Objetivo anual de visitas',
  'scout.scorecard.annualTargetDemos': 'Objetivo anual de demos',
  'scout.scorecard.annualTargetNetRevenue': 'Ingresos netos (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Objetivo anual de ingresos netos en euros',
  'scout.scorecard.monthlyOverrides': 'Desviaciones mensuales',
  'scout.scorecard.table.month': 'Mes',
  'scout.scorecard.table.reason': 'Motivo',
  'scout.scorecard.derivedTargets': 'Objetivos derivados',
  'scout.scorecard.dailyTargetLabel': 'Objetivo diario: {{count}} visitas',
  'scout.scorecard.weeklyTargetLabel': 'Objetivo semanal: {{count}} visitas',
  'scout.scorecard.save': 'Guardar',
  'scout.scorecard.heatmap.visits': 'Visitas',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Ingresos',
  'scout.scorecard.heatmap.low': 'Bajo',
  'scout.scorecard.heatmap.high': 'Alto',
  'scout.scorecard.heatmap.scaleA11y': 'Escala de color de bajo a alto',
  'scout.scorecard.heatmap.loading': 'Cargando mapa…',
  // Scout mission control
  'scout.missionControl.teamOverview': 'Tu equipo y sus áreas de código postal',
  'scout.missionControl.jokerLimitPerDay': 'Límite de comodines por día',
  'scout.missionControl.jokerLimitUpdated': 'Límite de comodines actualizado.',
  'scout.missionControl.jokerLimitSaveFailed': 'No se pudo guardar el límite de comodines.',
  'scout.missionControl.selectTeam': 'Seleccionar equipo',
  'scout.missionControl.none': 'Ninguno',
  'scout.missionControl.addPlzAreaFor': 'Añadir área de CP para',
  'scout.missionControl.addPlzArea': 'Añadir área de CP',
  'scout.missionControl.noTeamMembersFound': 'No se encontraron miembros del equipo.',
  'scout.missionControl.orders': 'Pedidos',
  'scout.missionControl.resetSettings': 'Restablecer ajustes',
  'scout.missionControl.saveSettings': 'Guardar ajustes',
  'scout.missionControl.territorySaturation': 'Saturación territorial (CP)',
  'scout.missionControl.day': 'Día',
  'scout.missionControl.selectDay': 'Seleccionar día',
  'scout.missionControl.week': 'Semana',
  'scout.missionControl.selectWeek': 'Seleccionar semana',
  'scout.missionControl.month': 'Mes',
  'scout.missionControl.selectMonth': 'Seleccionar mes',
  'scout.missionControl.planFulfillment': 'Cumplimiento del plan',
  'scout.missionControl.plzPrefixPlaceholder': 'Prefijo CP (ej. 70)',
  'scout.missionControl.plzPrefix': 'Prefijo CP',
  'scout.missionControl.addPlzToWhitelist': 'Añadir prefijo CP a lista blanca',
  'scout.missionControl.addPlzToGreylist': 'Añadir prefijo CP a lista gris',
  'scout.missionControl.addPlzToYellowlist': 'Añadir prefijo CP a lista amarilla',
  'scout.missionControl.addNewTeamMember': 'Añadir nuevo miembro al equipo',
  'scout.missionControl.lastModified': 'Última modificación',
  'scout.missionControl.outsideAreaRules': 'Reglas fuera de zona',
  'scout.missionControl.outsidePlzPolicy': 'Normativa para CP fuera de las listas',
  'scout.missionControl.enableOutsideWarning': 'Activar aviso para CP fuera de zona',
  'scout.missionControl.requireOutsideApproval': 'Requerir aprobación para CP fuera de zona',
  'scout.missionControl.rejectOutsidePlz': 'Rechazar CP fuera de zona',
  'scout.missionControl.checkPlz': 'Comprobar CP o prefijo CP',
  'scout.missionControl.check': 'Comprobar',
  'scout.missionControl.error': 'Error',
  'scout.missionControl.success': 'Éxito',
  'scout.missionControl.userProfileNotFound': 'Perfil de usuario no encontrado',
  'scout.missionControl.plzAreasUpdated': 'Áreas de CP actualizadas',
  'scout.missionControl.plzAreasSaveFailed': 'No se pudieron guardar las áreas de CP',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Configuración de representante',
  'scout.missionControl.repConfig.repName': 'Nombre / Email',
  'scout.missionControl.repConfig.industries': 'Industrias',
  'scout.missionControl.repConfig.products': 'Productos',
  'scout.missionControl.repConfig.plz': 'CP',
  'scout.missionControl.repConfig.loadError': 'Error al cargar la configuración de representante',
  'scout.missionControl.repConfig.saveError': 'Error al guardar',
  'scout.missionControl.repConfig.savedTitle': 'Guardado',
  'scout.missionControl.repConfig.savedDesc': 'Configuración de representante actualizada',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Límite de comodines por día',
  'scout.missionControl.jokerConfig.description': 'Número máximo de usos de comodín por representante y día.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Máx. por día',
  'scout.missionControl.jokerConfig.loadError': 'Error al cargar la configuración de comodines',
  'scout.missionControl.jokerConfig.saveError': 'Error al guardar',
  'scout.missionControl.jokerConfig.savedTitle': 'Guardado',
  'scout.missionControl.jokerConfig.savedDesc': 'Límite de comodines actualizado',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Tasa de demos',
  'scout.missionControl.diagnostics.visitDepth': 'Profundidad de visita',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Seleccionar todos los resultados',
  'scout.unternehmenssuche.openingHours': 'HORARIO',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporalmente cerrado',
  'scout.unternehmenssuche.startSearch': 'Iniciar búsqueda',
  'scout.unternehmenssuche.searchRunning': 'Buscando...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Ajusta los criterios de búsqueda o inténtalo de nuevo.',
  'scout.unternehmenssuche.selectCompanyType': 'Seleccionar tipo de empresa',
  'scout.unternehmenssuche.openingHoursTime': 'Hora de apertura',
  'scout.unternehmenssuche.noTimeNeeded': 'No hace falta hora',
  'scout.unternehmenssuche.addConditions': 'Añade condiciones para afinar la búsqueda',
  'scout.unternehmenssuche.addCondition': 'Añadir condición',
  'scout.unternehmenssuche.addGroup': 'Añadir grupo',
  'scout.unternehmenssuche.savedSearchName': 'Nombre de la búsqueda guardada',
  'scout.unternehmenssuche.saveCurrentSearch': 'Guardar búsqueda actual',
  'scout.unternehmenssuche.savedSearches': 'Búsquedas guardadas',
  'scout.unternehmenssuche.noSavedSearches': 'No hay búsquedas guardadas.',
  'scout.unternehmenssuche.keywordPlaceholder': 'ej. Restaurante, Bar, Panadería',
  'scout.unternehmenssuche.addWaypoint': 'Añadir parada',
  'scout.unternehmenssuche.locationPlaceholder': 'ej. Madrid Plaza Mayor',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Mostrar u ocultar filtros adicionales',
  'scout.unternehmenssuche.additionalFilters': 'Filtros adicionales',
  'scout.unternehmenssuche.saveSearchAsFile': 'Guardar búsqueda como archivo',
  'scout.unternehmenssuche.loadSearchFromFile': 'Cargar búsqueda desde archivo',
  'scout.unternehmenssuche.checkSearchTerms': 'Comprueba los términos de búsqueda o inténtalo de nuevo.',

  // Search overlay
  'search.overlay.hint': 'Escribe y pulsa Enter o haz clic en Buscar.',
  'search.overlay.placeholder': 'Buscar (/) recursos, documentación y más',
  'search.overlay.searchLabel': 'Buscar',
  'search.overlay.noResults': 'No hay resultados para "{{query}}"',
  'search.overlay.tryDifferent': 'Prueba otros términos o revisa la ortografía.',
  'search.overlay.topResults': 'Mejores resultados',
  'search.overlay.documentation': 'Documentación · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Ubicación + radio',
  'scout.unternehmenssuche.routeCorridor': 'Ruta + corredor',
  'scout.unternehmenssuche.withoutLocation': 'Sin ubicación',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Mapa de calor de actividad (CP-2)',
  'scout.preferences.defaultRegionLabel': 'Región por defecto',
  'scout.preferences.selectRegionPlaceholder': 'Seleccionar región',
  'scout.preferences.defaultStatusLabel': 'Estado por defecto',
  'scout.preferences.selectDefaultStatus': 'Seleccionar estado por defecto',
  'scout.preferences.statusDraft': 'Borrador',
  'scout.preferences.statusActive': 'Activo',
  'scout.preferences.statusCompleted': 'Completado',
  'scout.preferences.statusArchived': 'Archivado',
  'scout.preferences.saving': 'Guardando...',
  'scout.preferences.plzPrefixes': 'Prefijos CP para misiones',
  'scout.preferences.plzPrefixesPlaceholder': 'Introduce prefijos CP separados por comas (ej. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Longitud máx. de ruta (km)',
  'scout.preferences.maxRouteLengthDescription': 'Longitud máxima de ruta en kilómetros',
  'scout.preferences.autoGenerateMissions': 'Generar misiones automáticamente (automatización nocturna)',
  'scout.preferences.autoGenerateDescription': 'Si está activo, las misiones se generan automáticamente según tus ajustes.',
  'scout.preferences.defaultAssigneeLabel': 'Persona responsable por defecto',
  'scout.preferences.defaultAssigneePlaceholder': 'Introduce la persona responsable por defecto',
  'scout.preferences.defaultAssigneeAria': 'Persona responsable por defecto',
  'scout.preferences.defaultLeadCountLabel': 'Número de leads por defecto',
  'scout.preferences.defaultLeadCountAria': 'Número de leads por defecto',
  'scout.preferences.defaultDurationLabel': 'Duración por defecto (días)',
  'scout.preferences.defaultDurationAria': 'Duración por defecto en días',
  'scout.preferences.autoAssignLabel': 'Asignar misiones automáticamente a la persona responsable por defecto',
  'scout.preferences.productFamiliesLabel': 'Familias de productos',
  'scout.preferences.industryCodesLabel': 'Industrias',
  'scout.preferences.keywordsLabel': 'Palabras clave',
  'scout.preferences.keywordsPlaceholder': 'ej. hormigón, solera',
  'scout.preferences.minLeadsLabel': 'Mín. leads por misión',
  'scout.preferences.minLeadsAria': 'Mínimo de leads por misión',
  'scout.preferences.maxLeadsLabel': 'Máx. leads por misión',
  'scout.preferences.maxLeadsAria': 'Máximo de leads por misión',
  'scout.preferences.dailyQuotaLabel': 'Número de misiones por día',
  'scout.preferences.dailyQuotaAria': 'Máximo de misiones por día',
  'scout.preferences.dailyQuotaHelper': 'Número máximo de misiones auto-generadas por día (1-3)',
  'scout.dailyPlanning.inField': 'En campo',
  'scout.dailyPlanning.completed': 'Completado',
  'scout.dailyPlanning.openDay': 'Abrir día',
  'scout.dailyPlanning.dayMarkedCompleted': 'Este día está marcado como completado.',
  'scout.dailyPlanning.statusVisited': 'Visitado',
  'scout.dailyPlanning.statusPlanned': 'Planificado',
  'scout.dailyPlanning.statusCompleted': 'Completado',
  'scout.createMission.title': 'Crear nueva misión',
  'scout.createMission.description': 'Elige nombre, filtros y asignaciones',
  'scout.createMission.nameLabel': 'Nombre',
  'scout.createMission.nameRequired': 'El nombre es obligatorio',
  'scout.createMission.namePlaceholder': 'ej. Madrid Norte — Refrigeración',
  'scout.createMission.nameAria': 'Nombre de la misión',
  'scout.createMission.regionLabel': 'Región (opcional)',
  'scout.createMission.regionPlaceholder': 'ej. CP 28xxx',
  'scout.createMission.regionAria': 'Región o CP',
  'scout.createMission.ownerLabel': 'Responsable',
  'scout.createMission.ownerPlaceholder': 'Correo electrónico',
  'scout.createMission.ownerAria': 'Correo del responsable',
  'scout.createMission.themeLabel': 'Tema (opcional)',
  'scout.createMission.themePlaceholder': 'ej. Refrigeración',
  'scout.createMission.themeAria': 'Tema de la misión',
  'scout.createMission.productLabel': 'Producto (opcional)',
  'scout.createMission.productPlaceholder': 'ej. K-2000',
  'scout.createMission.productAria': 'Producto',
  'scout.createMission.cancel': 'Cancelar',
  'scout.createMission.save': 'Guardar',
  'scout.createMission.saveBusy': 'Guardando…',
  'scout.createMission.cancelAria': 'Cancelar creación de misión',
  'scout.createMission.saveAria': 'Guardar misión',
  'scout.createMission.saveBusyAria': 'Guardando misión',

  // Inventory

  // Sales

  // Purchase


  'common.error': 'Error',
  'common.next': 'Siguiente',

  // Settings
  'settings.description': 'Gestiona la configuración de la aplicación y las opciones de personalización',
  'settings.typography.title': 'Tipografía',
  'settings.typography.description': 'Ajusta el tamaño y la densidad del texto para mejor legibilidad o más densidad de información',
  'settings.typography.scale.title': 'Tamaño de texto',
  'settings.typography.scale.description': 'Estándar corresponde a la base Masterslight; Confort aumenta la fuente para sesiones largas',
  'settings.typography.scale.ariaLabel': 'Preset de tamaño de texto',
  'settings.typography.scale.compact': 'Compacto',
  'settings.typography.scale.standard': 'Estándar',
  'settings.typography.scale.comfort': 'Confort',
  'settings.tabs.appearance': 'Apariencia',
  'settings.tabs.account': 'Cuenta',
  'settings.tabs.notifications': 'Notificaciones',
  'settings.tabs.security': 'Seguridad',
  'settings.language.title': 'Configuración de idioma',
  'settings.language.description': 'Elige tu idioma preferido para la interfaz de la aplicación',
  'settings.language.interfaceLanguage': 'Idioma de la interfaz',
  'settings.language.interfaceLanguageDesc': 'Elige el idioma para menús, botones y elementos de la interfaz',
  'settings.theme.title': 'Esquema de color',
  'settings.theme.description': 'Personaliza el aspecto y los colores de tu interfaz',
  'settings.theme.predefinedThemes': '¿Quieres elegir entre 10 temas predefinidos?',
  'settings.theme.goToThemeSettings': 'Ir a configuración de tema',
  'settings.themeSettings.title': 'Configuración de tema',
  'settings.themeSettings.description': 'Personaliza el aspecto de tu aplicación con temas predefinidos',
  'settings.themeSettings.themeDetails': 'Detalles del tema',
  'settings.themeSettings.themeId': 'ID de tema:',
  'settings.themeSettings.colorScheme': 'Esquema de color:',
  'settings.account.profile.title': 'Información del perfil',
  'settings.account.profile.description': 'Actualiza tu información personal y datos de la cuenta',
  'settings.account.profile.name': 'Nombre',
  'settings.account.profile.email': 'Correo electrónico',
  'settings.account.profile.role': 'Rol',
  'settings.account.profile.department': 'Departamento',
  'settings.account.profile.editProfile': 'Editar perfil',
  'settings.account.data.title': 'Gestión de datos',
  'settings.account.data.description': 'Gestiona la sincronización de datos y la configuración de copias de seguridad',
  'settings.account.data.cloudSync': 'Sincronización en la nube',
  'settings.account.data.cloudSyncEnabled': 'Tu configuración se sincroniza a la nube',
  'settings.account.data.cloudSyncDisabled': 'Sincronización en la nube desactivada (feature flag)',
  'settings.account.data.syncNow': 'Sincronizar ahora',
  'settings.notifications.title': 'Configuración de notificaciones',
  'settings.notifications.description': 'Configura cómo recibir las notificaciones',
  'settings.notifications.email.title': 'Notificaciones por correo',
  'settings.notifications.email.description': 'Recibir notificaciones por correo electrónico',
  'settings.notifications.push.title': 'Notificaciones push',
  'settings.notifications.push.description': 'Recibir notificaciones push en el navegador',
  'settings.notifications.system.title': 'Alertas del sistema',
  'settings.notifications.system.description': 'Notificaciones importantes del sistema',
  'settings.notifications.configure': 'Configurar',
  'settings.security.title': 'Configuración de seguridad',
  'settings.security.description': 'Gestiona la seguridad de tu cuenta y la configuración de privacidad',
  'settings.security.password.title': 'Contraseña',
  'settings.security.password.lastChanged': 'Último cambio hace 30 días',
  'settings.security.password.change': 'Cambiar',
  'settings.security.twoFactor.title': 'Autenticación de dos factores',
  'settings.security.twoFactor.description': 'Añade una capa adicional de seguridad',
  'settings.security.twoFactor.enable': 'Activar',
  'settings.security.sessions.title': 'Gestión de sesiones',
  'settings.security.sessions.description': 'Gestionar sesiones activas',
  'settings.security.sessions.view': 'Ver sesiones',
  'settings.company.title': 'Configuración de empresa',
  'settings.company.description': 'Gestiona la información y configuración de tu empresa',
  'settings.company.edit': 'Editar empresa',
  'settings.company.saveChanges': 'Guardar cambios',
  'settings.company.cancel': 'Cancelar',
  'settings.company.tabs.general': 'General',
  'settings.company.tabs.contact': 'Contacto',
  'settings.company.tabs.billing': 'Facturación',
  'settings.company.tabs.branding': 'Identidad de marca',
  'settings.company.general.companyInfo': 'Información de la empresa',
  'settings.company.general.companyName': 'Nombre de la empresa',
  'settings.company.general.legalName': 'Nombre legal',
  'settings.company.general.taxId': 'NIF/CIF',
  'settings.company.general.registrationNumber': 'Número de registro',
  'settings.company.general.industry': 'Sector',
  'settings.company.general.foundedYear': 'Año de fundación',
  'settings.company.general.employees': 'Número de empleados',
  'settings.company.general.industry.technology': 'Tecnología',
  'settings.company.general.industry.manufacturing': 'Fabricación',
  'settings.company.general.industry.retail': 'Comercio minorista',
  'settings.company.general.industry.healthcare': 'Sanidad',
  'settings.company.general.industry.finance': 'Finanzas',
  'settings.company.general.industry.other': 'Otro',
  'settings.company.address.title': 'Información de dirección',
  'settings.company.address.street': 'Dirección',
  'settings.company.address.city': 'Ciudad',
  'settings.company.address.state': 'Estado/Provincia',
  'settings.company.address.zipCode': 'Código postal',
  'settings.company.address.country': 'País',
  'settings.company.address.country.us': 'Estados Unidos',
  'settings.company.address.country.ca': 'Canadá',
  'settings.company.address.country.uk': 'Reino Unido',
  'settings.company.address.country.de': 'Alemania',
  'settings.company.address.country.fr': 'Francia',
  'settings.company.address.country.other': 'Otro',
  'settings.company.contact.title': 'Información de contacto',
  'settings.company.contact.phone': 'Teléfono',
  'settings.company.contact.email': 'Correo electrónico',
  'settings.company.contact.website': 'Sitio web',
  'settings.company.contact.supportEmail': 'Correo de soporte',
  'settings.company.billing.title': 'Configuración de facturación',
  'settings.company.billing.currency': 'Moneda',
  'settings.company.billing.taxRate': 'Tipo impositivo (%)',
  'settings.company.billing.paymentTerms': 'Condiciones de pago',
  'settings.company.billing.billingCycle': 'Ciclo de facturación',
  'settings.company.billing.paymentTerms.net15': 'Neto 15',
  'settings.company.billing.paymentTerms.net30': 'Neto 30',
  'settings.company.billing.paymentTerms.net45': 'Neto 45',
  'settings.company.billing.paymentTerms.net60': 'Neto 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Vencimiento a la recepción',
  'settings.company.billing.cycle.monthly': 'Mensual',
  'settings.company.billing.cycle.quarterly': 'Trimestral',
  'settings.company.billing.cycle.annually': 'Anual',
  'settings.company.billing.cycle.custom': 'Personalizado',
  'settings.company.billing.summary.title': 'Resumen de facturación',
  'settings.company.billing.summary.currentPlan': 'Plan actual',
  'settings.company.billing.summary.monthlyCost': 'Coste mensual',
  'settings.company.billing.summary.nextBillingDate': 'Próxima fecha de facturación',
  'settings.company.billing.summary.paymentMethod': 'Método de pago',
  'settings.company.billing.summary.status': 'Estado',
  'settings.company.billing.summary.active': 'Activo',
  'settings.company.branding.title': 'Identidad de marca y apariencia',
  'settings.company.branding.logo': 'Logo de la empresa',
  'settings.company.branding.uploadLogo': 'Subir logo',
  'settings.company.branding.logoHint': 'PNG, JPG hasta 2 MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Subir favicon',
  'settings.company.branding.faviconHint': 'ICO, PNG hasta 1 MB',
  'settings.company.branding.primaryColor': 'Color primario',
  'settings.company.branding.secondaryColor': 'Color secundario',

  'settings.usersRoles.stats.totalUsers': 'Total usuarios',
  'settings.usersRoles.stats.activeUsers': 'usuarios activos',
  'settings.usersRoles.stats.totalRoles': 'Total roles',
  'settings.usersRoles.stats.roleConfigurations': 'Configuraciones de roles',
  'settings.userManagement.title': 'Gestión de usuarios',
  'settings.userManagement.description': 'Gestiona usuarios, roles y configuración del sistema',
  'settings.userManagement.addUser': 'Añadir usuario',
  'settings.userManagement.editUser': 'Editar usuario',
  'settings.userManagement.createNewUser': 'Crear nuevo usuario',
  'settings.userManagement.updateUserInfo': 'Actualizar información del usuario',
  'settings.userManagement.addNewUser': 'Añadir un nuevo usuario al sistema',
  'settings.userManagement.tabs.users': 'Usuarios',
  'settings.userManagement.tabs.appAccess': 'Acceso a apps',
  'settings.userManagement.tabs.roles': 'Roles',
  'settings.userManagement.toast.userCreated': 'Usuario creado correctamente',
  'settings.userManagement.toast.userUpdated': 'Usuario actualizado correctamente',
  'settings.userManagement.toast.userDeleted': 'Usuario eliminado correctamente',
  'settings.userManagement.toast.roleCreated': 'Rol creado correctamente',
  'settings.userManagement.toast.roleUpdated': 'Rol actualizado correctamente',
  'settings.userManagement.toast.roleDeleted': 'Rol eliminado correctamente',
  'settings.userManagement.toast.error': 'No se pudo crear el usuario',
  'settings.userManagement.toast.errorUpdate': 'No se pudo actualizar el usuario',
  'settings.userManagement.toast.errorDelete': 'No se pudo eliminar el usuario',
  'settings.userManagement.toast.errorRoleCreate': 'No se pudo crear el rol',
  'settings.userManagement.toast.errorRoleUpdate': 'No se pudo actualizar el rol',
  'settings.userManagement.toast.errorRoleDelete': 'No se pudo eliminar el rol',
  'settings.integrations.settings.security.enabled': 'Activado',
  'settings.integrations.settings.security.disabled': 'Desactivado',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'Contactos CRM',
  'crm.contacts.description': 'Gestionar contactos de clientes y proveedores con información de dirección',
  'crm.contacts.add': 'Añadir contacto',
  'crm.contacts.edit': 'Editar contacto',
  'crm.contacts.delete': 'Eliminar contacto',
  'crm.contacts.view360': 'Vista 360°',
  'crm.contacts.unassigned': 'Sin asignar',
  'crm.contacts.type.customer': 'Cliente',
  'crm.contacts.type.supplier': 'Proveedor',
  'crm.contacts.type.partner': 'Socio',
  'crm.contacts.type.prospect': 'Prospecto',
  'crm.contacts.status.active': 'Activo',
  'crm.contacts.status.inactive': 'Inactivo',
  'crm.contacts.status.suspended': 'Suspendido',
  'crm.contacts.validation.companyRequired': 'El nombre de la empresa es obligatorio',
  'crm.contacts.validation.streetRequired': 'La dirección es obligatoria',
  'crm.contacts.validation.postalRequired': 'El código postal es obligatorio',
  'crm.contacts.validation.cityRequired': 'La ciudad es obligatoria',
  'crm.contacts.validation.countryRequired': 'El país es obligatorio',
  'crm.contacts.validation.nameRequired': 'El nombre del contacto es obligatorio',
  'crm.contacts.validation.emailInvalid': 'Correo electrónico no válido',
  'crm.contacts.validation.phoneRequired': 'El teléfono es obligatorio',
  'crm.contacts.validation.salesPersonRequired': 'El representante de ventas es obligatorio',
  'crm.contacts.validation.ordererNameRequired': 'El nombre del ordenante es obligatorio',
  'crm.contacts.validation.roleRequired': 'El rol es obligatorio',
  'crm.contacts.validation.hoursRequired': 'Las horas son obligatorias',
  'crm.openMenu': 'Abrir menú',

  // CRM - Leads
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Gestionar leads de ventas y seguir la conversión',
  'crm.leads.add': 'Añadir lead',
  'crm.leads.edit': 'Editar lead',
  'crm.leads.delete': 'Eliminar lead',
  'crm.leads.status.new': 'Nuevo',
  'crm.leads.status.contacted': 'Contactado',
  'crm.leads.status.qualified': 'Cualificado',
  'crm.leads.status.proposal': 'Oferta',
  'crm.leads.status.negotiation': 'Negociación',
  'crm.leads.status.closedWon': 'Ganado',
  'crm.leads.status.closedLost': 'Perdido',
  'crm.leads.source.website': 'Sitio web',
  'crm.leads.source.referral': 'Recomendación',
  'crm.leads.source.email': 'Correo',
  'crm.leads.source.phone': 'Teléfono',
  'crm.leads.source.social': 'Redes sociales',
  'crm.leads.source.other': 'Otro',
  'crm.leads.value': 'Valor',
  'crm.leads.lastContact': 'Último contacto',
  'crm.leads.notes': 'Notas',
  'crm.leads.search': 'Buscar leads...',
  'crm.leads.filterByStatus': 'Filtrar por estado',
  'crm.leads.filterBySource': 'Filtrar por fuente',
  'crm.leads.totalLeads': 'Total leads',
  'crm.leads.pipelineValue': 'Valor del pipeline',
  'crm.leads.qualifiedLeads': 'Leads cualificados',

  // Visit Report
  'visitReport.title': 'Informe de visita',
  'visitReport.createTitle': 'Crear informe de visita',
  'visitReport.titleFor': 'Informe de visita para {{name}}',
  'visitReport.visitType': 'Tipo de visita',
  'visitReport.coldVisit': 'Visita en frío',
  'visitReport.appointment': 'Cita',
  'visitReport.salesOutcome': 'Resultado comercial',
  'visitReport.noContact': 'Sin contacto',
  'visitReport.conversation': 'Conversación',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Pedido',
  'visitReport.orderValue': 'Valor del pedido (EUR)',
  'visitReport.nextStep': 'Próximo paso',
  'visitReport.callback': 'Llamada de seguimiento',
  'visitReport.sendOffer': 'Enviar oferta',
  'visitReport.revisit': 'Nueva visita',
  'visitReport.completed': 'Completado',
  'visitReport.appointmentWindow': 'Ventana de cita (opcional)',
  'visitReport.from': 'Desde',
  'visitReport.to': 'Hasta',
  'visitReport.contactName': 'Nombre del interlocutor',
  'visitReport.enterName': 'Introducir nombre',
  'visitReport.roleFunction': 'Función / Rol',
  'visitReport.enterRole': 'Introducir función',
  'visitReport.isDecisionMaker': '¿Es decisor?',
  'visitReport.decisionMakerName': 'Nombre del decisor',
  'visitReport.decisionMakerRole': 'Función del decisor',
  'visitReport.email': 'Correo (opcional)',
  'visitReport.phone': 'Teléfono (opcional)',
  'visitReport.notes': 'Notas (opcional)',
  'visitReport.additionalInfo': 'Información adicional...',
  'visitReport.productsDiscussed': '¿Productos comentados?',
  'visitReport.annualDemand': 'Demanda anual',
  'visitReport.select': 'Seleccionar',
  'visitReport.interest': 'Interés',
  'visitReport.interestHigh': 'alto',
  'visitReport.interestMedium': 'medio',
  'visitReport.interestLow': 'bajo',
  'visitReport.modelFeedback': '¿Fue adecuada la recomendación del sistema?',
  'visitReport.feedbackYes': 'Sí',
  'visitReport.feedbackPartially': 'Parcialmente',
  'visitReport.feedbackNo': 'No',
  'visitReport.feedbackNotSeen': 'No visto',
  'visitReport.branchCorrect': '¿Sector correcto? (opcional)',
  'visitReport.selectBranch': 'Seleccionar sector',
  'visitReport.branchConstruction': 'Construcción',
  'visitReport.branchIndustry': 'Industria',
  'visitReport.branchTrade': 'Comercio',
  'visitReport.branchService': 'Servicios',
  'visitReport.noInterestReason': 'Motivo de no interés',
  'visitReport.wrongProduct': 'Producto incorrecto',
  'visitReport.wrongTiming': 'Momento inadecuado',
  'visitReport.existingSupplier': 'Proveedor actual',
  'visitReport.noBudget': 'Sin presupuesto',
  'visitReport.noNeed': 'Sin necesidad',
  'visitReport.decisionMakerNotReached': 'Decisor no localizado',
  'visitReport.additionalRemarks': 'Observaciones adicionales (opcional)',
  'visitReport.error': 'Error',
  'visitReport.validationError': 'Selecciona tipo de visita y resultado comercial.',
  'visitReport.deferralNotPossible': 'No se puede aplazar',
  'visitReport.maxDeferralReached': 'Ya has aplazado el último informe. Complétalo.',
  'visitReport.reportDeferred': 'Informe aplazado',
  'visitReport.deferralMessage': 'Puedes completar el informe más tarde.',
  'visitReport.reportCreated': 'Informe de visita creado',
  'visitReport.reportSaved': 'Informe de visita guardado.',
  'visitReport.reportSavedFor': 'Informe de visita para {{name}} guardado.',
  'visitReport.reportError': 'No se pudo crear el informe de visita.',
  'visitReport.stepOf': 'Paso {{current}} de {{total}}',
  'visitReport.back': 'Atrás',
  'visitReport.cancel': 'Cancelar',
  'visitReport.inAHurry': 'Tengo prisa',
  'visitReport.next': 'Siguiente',
  'visitReport.saving': 'Guardando...',
  'visitReport.finishVisit': 'Finalizar visita',
  'visitReport.contactNotes': 'Información adicional del interlocutor...',
  'visitReport.callingQueue.prompt': '¿Preparar una llamada de cita con IA para este lead?',
  'visitReport.callingQueue.yes': 'Sí, añadir a la cola',
  'visitReport.callingQueue.no': 'No',
  'visitReport.callingQueue.toast': 'Lead añadido a la cola de llamadas.',

  // Admin (SS-145)

  // Learning (SS-145 extra)
  'learning.lehrplan.title': 'Plan de estudios',
  'learning.lehrplan.subtitle': 'Gestionar plan de estudios y objetivos de aprendizaje',
  'learning.curriculumPlanning.title': 'Planificación curricular',
  'learning.curriculumPlanning.subtitle': 'Estructurar el plan y asignar contenidos',

  // AI + app
  'app.routes.loadingSettings': 'Cargando configuración...',
  'companySearch.filters.companySize': 'Tamaño de empresa',
  'curriculum.modules.pillar': 'Eje',
  'curriculum.modules.selectLevel': 'Seleccionar nivel',
  'curriculum.modules.selectPillar': 'Seleccionar eje',
  'curriculum.modules.selectPillarOption': 'Seleccionar eje',
  'learning.lessonViewer.audioNotSupported': 'Tu navegador no admite audio.',
  'learning.lessonViewer.complete': 'Completar',
  'learning.lessonViewer.formatNotSupported': 'Formato no admitido',
  'learning.lessonViewer.videoNotSupported': 'Tu navegador no admite vídeo.',
  'learning.moduleEditor.pillar': 'Eje',
  'learning.moduleEditor.pillarLabel': 'Eje',
  'learning.tabs.availableLessons': 'Lecciones disponibles',
  'learning.tabs.availableQuizzes': 'Quizzes disponibles',
  'missions.management.demoPerformed': 'Demo realizada',
  'missions.management.demoPerformedLabel': 'Demo realizada',
  'missions.management.kpiDescription': 'Decisor contactado, demo realizada, ingresos',
  'missions.management.moreActions': 'Más acciones para la misión',
  'missions.management.publish': 'Publicar',
  'missions.management.searchPlaceholder': 'Buscar (nombre/región/tema/producto)',
  'mobile.layout.closeMenu': 'Cerrar menú',
  'mobile.layout.menu': 'Menú',
  'mobile.layout.noOfflineContent': 'Sin contenido disponible sin conexión',
  'mobile.layout.offlinePerformance': 'Mejor rendimiento sin conexión',
  'navigation.tileCard.openActions': 'Abrir acciones de la tile',
  'navigation.appOverview': 'Resumen de apps',

  // Modals
  'modals.assignMissionModal.close': 'Cerrar',
  'modals.assignMissionModal.searchPlaceholder': 'Buscar (título/sector)',
  'modals.assignMissionModal.searchAriaLabel': 'Buscar',
  'modals.missionQuickViewModal.description': 'Vista rápida de la misión. Abre la página de la misión para más detalles.',
  'modals.missionQuickViewModal.close': 'Cerrar',
  'modals.missionQuickViewModal.openDetails': 'Abrir detalles',
  'modals.missionQuickViewModal.openDetailsAria': 'Abrir detalle de misión',
  'modals.leadDetailModal.close': 'Cerrar',
  'modals.leadDetailModal.whoIsThis': '¿Quién es?',
  'modals.leadDetailModal.whatDoTheyNeed': '¿Qué necesitan?',
  'modals.leadDetailModal.whatDoISay': '¿Qué digo?',
  'modals.leadDetailModal.moreProducts': 'Más productos',
  'modals.regionDetailsModal.description': 'Resumen del detalle de la misión. Solo lectura.',
  'modals.regionDetailsModal.edit': 'Editar',
  'modals.regionDetailsModal.close': 'Cerrar',
  'modals.editRegionModal.close': 'Cerrar',
  'modals.editRegionModal.description': 'Editar hora y nota de la misión. El estado es solo lectura.',
  'modals.editRegionModal.statusReadonlySrOnly': 'El estado es solo lectura.',
  'modals.splitAssignmentDialog.actionLabel': 'Seleccionar acción',
  'modals.splitAssignmentDialog.confirmButton': 'Confirmar',
  'modals.addAppointmentModal.companyAriaLabel': 'Seleccionar o escribir empresa / lead',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmado',
  'modals.rejectLead.title': 'Rechazar lead',
  'modals.rejectLead.closeAria': 'Cerrar diálogo',
  'modals.rejectLead.description': 'Selecciona al menos un motivo de rechazo.',
  'modals.rejectLead.reasonsLabel': 'Motivos de rechazo',
  'modals.rejectLead.reasonsError': 'Selecciona al menos un motivo.',
  'modals.rejectLead.otherReasonLabel': 'Otro motivo',
  'modals.rejectLead.otherReasonPlaceholder': 'Describe el motivo...',
  'modals.rejectLead.otherReasonAria': 'Otro motivo de rechazo',
  'modals.rejectLead.otherReasonError': 'Introduce un motivo.',
  'modals.rejectLead.cancel': 'Cancelar',
  'modals.rejectLead.confirm': 'Rechazar ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Ya no activo',
  'modals.rejectLead.reason.temporarilyClosed': 'Cerrado temporalmente',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Conocido y no adecuado',
  'modals.rejectLead.reason.noInterest': 'Sin interés',
  'modals.rejectLead.reason.wrongContact': 'Contacto incorrecto',
  'modals.rejectLead.reason.other': 'Otro',

  // Preferences / Scout
  'scout.preferences.badenWuerttemberg': 'Baden-Wurtemberg',
  'scout.preferences.thueringen': 'Turingia',
  'scout.sprints.ciEstimate': 'Estimación de tiempo de CI',
  'scout.sprints.estimatedMinutes': 'Minutos estimados',
  'scout.dailyPlanning.jokerAdd': 'Usar comodín',
  'scout.dailyPlanning.jokerTitle': 'Parada comodín',
  'scout.dailyPlanning.jokerUsed': 'usado',
  'scout.dailyPlanning.jokerLimitReached': 'Límite diario de paradas comodín alcanzado.',
  'scout.dailyPlanning.jokerCompany': 'Empresa',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Introducir nombre de empresa',
  'scout.dailyPlanning.jokerReason': 'Motivo',
  'scout.dailyPlanning.jokerReasonPlaceholder': '¿Por qué se necesita esta parada?',
  'scout.dailyPlanning.jokerCancel': 'Cancelar',
  'scout.dailyPlanning.jokerSubmit': 'Usar comodín',
  'scout.dailyPlanning.jokerCreateError': 'No se pudo crear la parada comodín.',

  // Scout Visit Report — Rejection / Compliance
  'scout.visitReport.compliance.title': 'Informes de visita pendientes',
  'scout.visitReport.compliance.description': 'Tienes {{count}} informes de visita pendientes. Complétalos primero.',
  'scout.visitReport.compliance.lockoutTitle': 'Informes requeridos',
  'scout.visitReport.compliance.lockoutDescription': 'Completa todos los informes de visita pendientes antes de continuar.',
  'scout.visitReport.compliance.deferButton': 'Rellenar más tarde',
  'scout.visitReport.compliance.deferCount': '{{remaining}} aplazamientos restantes',
  'scout.visitReport.compliance.noDeferrals': 'No quedan aplazamientos',
  'scout.visitReport.compliance.fillReport': 'Rellenar informe',
  'scout.visitReport.compliance.morningLockout': 'Planificación diaria bloqueada hasta completar todos los informes pendientes.',

  // Settings (address, audit close, sprints, styleGuide, tickets, ui, unternehmenssuche, weeklyPlanning)
  'styleGuide.charts.noStatusColors': 'Los gráficos no deben usar colores de estado',
  'styleGuide.confirmation': 'Confirmación',
  'styleGuide.description': 'Descripción',
  'styleGuide.statusSemantics.success': 'Éxito = Completado / OK',
  'tickets.list.filterPriority': 'Filtrar por prioridad',
  'ui.calendar.nextMonth': 'Mes siguiente',
  'ui.errorBoundary.returnToDashboard': 'Volver al panel',
  'ui.impersonation.selectImpersonation': 'Seleccionar suplantación',
  'ui.impersonation.selectUser': 'Seleccionar usuario:',
  'ui.routingPreview.openAppleMaps': 'Abrir en Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Abrir en Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} paradas · {{distance}} km · {{time}} min (estimado)',
  'ui.routingPreview.title': 'Vista previa de ruta',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Notas adicionales',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Añadir cita',
  'scout.help.selectArticle': 'Elige un artículo a la izquierda o usa la búsqueda para abrir un artículo de ayuda.',

  // PO Sprints (page), Purchase, Sales

  // Scout Wochenplanung aggregates, Mission Control planView

  // CRM flat keys
  'crm.leads': 'Leads',
  'crm.closedWon': 'Cierres ganados',
  'crm.searchPlaceholder': 'Buscar leads...',
  'crm.name': 'Nombre',
  'crm.company': 'Empresa',
  'crm.contact': 'Contacto',
  'crm.source': 'Fuente',
  'crm.value': 'Valor',
  'crm.lastContact': 'Último contacto',
  'crm.viewDetails': 'Ver detalles',
  'crm.editLead': 'Editar lead',
  'crm.addNote': 'Añadir nota',
  'crm.convertToCustomer': 'Convertir en cliente',
  'crm.deleteLead': 'Eliminar lead',
  'crm.leadDetails': 'Detalles del lead',
  'crm.addNewLead': 'Añadir nuevo lead',
  'crm.viewLeadDetails': 'Ver detalles del lead',
  'crm.createNewLead': 'Crear nuevo lead',
  'crm.fullName': 'Nombre completo',
  'crm.email': 'Correo electrónico',
  'crm.phone': 'Teléfono',
  'crm.estimatedValue': 'Valor estimado',
  'crm.notes': 'Notas',
  'crm.status.new': 'Nuevo',
  'crm.status.contacted': 'Contactado',
  'crm.status.qualified': 'Cualificado',
  'crm.status.proposal': 'Oferta',
  'crm.status.negotiation': 'Negociación',
  'crm.status.closedWon': 'Ganado',
  'crm.status.closedLost': 'Perdido',
  'crm.source.website': 'Sitio web',
  'crm.source.referral': 'Recomendación',
  'crm.source.tradeShow': 'Feria',
  'crm.source.coldCall': 'Llamada en frío',
  'crm.source.socialMedia': 'Redes sociales',
  'crm.source.emailCampaign': 'Campaña de email',

  // Supplier onboarding — Form
  'country.US': 'Estados Unidos',
  'country.CA': 'Canadá',
  'country.MX': 'México',
  'country.GB': 'Reino Unido',
  'country.DE': 'Alemania',
  'country.FR': 'Francia',
  'country.other': 'Otro',

  // Missing keys (added from en/de; scout.dailyPlanning.* already present)
  'common.saving': 'Guardando…',
  'common.archive': 'Archivar',
  'scout.missions.industries.placeholder': 'Seleccionar sectores',
  'scout.missions.industries.search': 'Buscar sectores...',
  'scout.missions.industries.empty': 'No se encontraron sectores',
  'scout.missions.products.placeholder': 'Seleccionar familias de productos',
  'scout.missions.products.search': 'Buscar familias de productos...',
  'scout.missions.products.empty': 'No se encontraron familias de productos',
  'scout.search.selectStatus': 'Seleccionar estado...',
  'missions.management.decisionMakerMet': 'Decisor contactado',
  'missions.management.wonAmount': 'Importe ganado',
  'common.active': 'Activo',
  'common.archived': 'Archivado',
  'common.planned': 'Planificado',
  'missionControl.totalLeads': 'Total de leads',
  'missionControl.completedLeads': 'Leads completados',

  'survey.contact.name': 'Nombre',
  'survey.contact.namePlaceholder': 'Introducir nombre',
  'survey.contact.function': 'Función / Rol',
  'survey.contact.functionPlaceholder': 'Introducir función',
  'survey.contact.email': 'Correo electrónico',
  'survey.contact.emailPlaceholder': 'Introducir dirección de correo',
  'survey.contact.phone': 'Teléfono',
  'survey.contact.phonePlaceholder': 'Introducir número de teléfono',
  'survey.contact.isDecisionMaker': '¿Es decisor?',
}
